/**
 * JQuery
 */

import $ from "jquery";

window.jQuery = $;
window.$ = $;

/**
 * Bootstrap
 */

import {
  // Alert,       // Dismissible alerts
  // Button,      // Toggle button states
  // Carousel,    // Slideshow component
  Collapse, // Accordion-like collapsing elements
  // Dropdown,    // Dropdown menus
  Modal, // Popup modals
  // Offcanvas,   // Offcanvas sidebars
  // Popover,     // Pop-up content on hover/click (requires @popperjs/core)
  // ScrollSpy,   // Auto-updating navigation based on scroll position
  Tab, // Tabs and pills navigation
  // Toast,       // Small pop-up notifications
  // Tooltip      // Tooltips for elements (requires @popperjs/core)
} from "bootstrap";

/* Custom SCSS */
// import "./index.scss";
// import './style-login.scss';
// import './style-admin.scss';
// import './style-buttons.scss';

/**
 * Gsap
 */

// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);

// window.gsap = gsap;
// window.ScrollTrigger = ScrollTrigger;

/**
 * Swiper
 */

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.Swiper = Swiper;

/**
 * Utils
 */

// import massimo from "./js/massimo";
// massimo();

import navbar from "./js/navbar";
navbar();

import footer from "./js/footer";
footer();

// import sidebar from "./js/sidebar";
// sidebar();

import search from "./js/search";
search();

// import woocommerce from "./js/woocommerce";
// woocommerce();

// import scrollTop from "./js/scrollTop";
// scrollTop();

document.addEventListener("DOMContentLoaded", () => {
  const btns = document.querySelectorAll(".archive__menu__link");
  if (btns.length > 0) {
    btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const navHeight = (window.innerWidth < 992) ? 0 : 72;
          setTimeout(() => {
            const headerHeight = document.querySelector(".header").offsetHeight;
            const content = document.querySelector(".archive__content__section");
            const targetPosition = content.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: targetPosition - headerHeight - navHeight,
              behavior: "smooth",
            });
          }, 300);
        // }
      });
    });
  }
});
